import { Link } from 'react-router';
import { formatPeso, presetRange, timeSeries, totalSpent } from '@tahi/core';
import type { TileSize } from '../../../tiles/registry';
import { ColumnChart } from '../../../ui/charts';
import { Money } from '../../../ui';
import { fitFontSize } from '../../../ui/fitText';
import { copy } from '../copy';
import { rangeLabel, spokenPeso, timeLabel } from '../format';
import { useEntries, useToday, useWeekStart } from '../hooks';
import { FOCUS } from '../styles';

export function WeekTile({ size }: { size: TileSize; config: unknown }) {
  const today = useToday();
  const week = presetRange('week', today, useWeekStart());
  const range = { start: week.start, end: today };
  const entries = useEntries(week) ?? [];
  const total = totalSpent(entries, range);

  return (
    <div
      role="group"
      className="flex flex-col gap-1"
      aria-label={`${copy.spentThisWeek}, ${spokenPeso(total)}`}
    >
      <Link
        to="/m/spending/breakdown?preset=week"
        className={`inline-flex min-h-11 items-center text-sm text-muted ${FOCUS}`}
      >
        {rangeLabel('week', week)}
      </Link>
      <div className="@container">
        <Money
          minor={total}
          className="block whitespace-nowrap leading-tight"
          style={{ fontSize: fitFontSize(formatPeso(total, { cents: 'always' }), 36) }}
        />
      </div>
      {size === 'wide' ? (
        <div className="mt-3">
          <ColumnChart
            ariaLabel={copy.thisWeek}
            items={timeSeries(entries, week, 'day').map((b) => ({
              key: b.key,
              label: timeLabel('day', b.key, 7),
              valueMinor: b.totalMinor,
            }))}
          />
        </div>
      ) : null}
    </div>
  );
}
